<script setup lang="ts">
import { computed, defineProps } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  checklist: any;
  status?: string;
};

const props = defineProps<Props>();
const checkboxList = computed(() => {
  if (props.status === "abnahme") {
    return props.checklist.filter((item: any) => !isCheckboxChecked(item));
  }
  return props.checklist;
});

/** Normalize checkbox value from backend (boolean or string "true"/"false") so display is never blank. */
function isCheckboxChecked(item: any): boolean {
  if (item?.value == null) return false;
  if (typeof item.value === "boolean") return item.value;
  return String(item.value).toLowerCase() === "true";
}

/** Fallback for missing name (e.g. checkbox inside repeatable group from API). */
function checkboxLabel(item: any): string {
  return item?.name ?? item?.id ?? "";
}

const { t } = useTranslate();
</script>

<template>
  <div>
    <h3
      class="text-xl leading-[32px] tracking-[0.01rem] pb-3 text-primary-text-color font-semibold"
    >
      {{ t("phase.checklist") }}
    </h3>
    <div
      v-for="input in checkboxList.filter((input:any)=> input.showInMissingInputs !== false)"
      :key="input.id"
      class="my-3"
    >
      <ul class="w-full list-none flex flex-col items-start gap-3">
        <li
          class="w-full flex items-center gap-2 justify-between border-b border-gray-100 pb-1"
        >
          <p
            class="relative text-sm sm:text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem] cursor-pointer"
            :class="isCheckboxChecked(input) ? 'line-through' : ''"
          >
            {{ checkboxLabel(input) }}
          </p>
          <img
            :class="isCheckboxChecked(input) ? 'hidden' : 'block'"
            class="cursor-pointer"
            src="@/assets/red-x-mark.svg"
            alt=""
          />
          <img
            :class="isCheckboxChecked(input) ? 'block' : 'hidden'"
            src="@/assets/accordion-check-icon.svg"
            alt="Check icon"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
